import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Offline } from 'react-detect-offline';
import PwaInstallPopup from '€components/PwaInstall/PwaInstallPopup';
import { OfflineNotificationBanner } from '€components/OfflineNotification';
import MetaLayout from '€layouts/MetaLayout';
import Dashboard from '€components/Dashboard';
import PostAuthLayout from '€layouts/PostAuthLayout';
import { Routes } from '€lib/routing/';
import UserProfileRouter from '€routers/UserProfileRouter';
import useDashboardData from '€hooks/useDashboardData';
import DashboardLayout from '../../layouts/DashboardLayout';
import ApplicationsList from '€components/ApplicationsList';
import useApplications from '€hooks/useApplications';
import ReferAClient from '€components/ReferAClient';

const PostAuth: React.FC = () => {
    useDashboardData();
    useApplications();

    return (
        <MetaLayout metaTitle="Loan | Applications">
            <Offline>
                <OfflineNotificationBanner />
            </Offline>
            <PwaInstallPopup />
            <Switch>
                <Route
                    path={[
                        Routes.UserSettings,
                        Routes.UserDetails,
                        Routes.UserProfile,
                        Routes.UserUpdatePassword,
                    ]}
                >
                    <PostAuthLayout display="flex" minHeight="100vh">
                        <UserProfileRouter />
                    </PostAuthLayout>
                </Route>
                <Route path={Routes.Dashboard}>
                    <DashboardLayout>
                        <Dashboard />
                    </DashboardLayout>
                </Route>
                <Route path={Routes.ApplicationsList}>
                    <DashboardLayout>
                        <ApplicationsList />
                    </DashboardLayout>
                </Route>
                <Route path={Routes.ReferAClient}>
                    <DashboardLayout>
                        <ReferAClient />
                    </DashboardLayout>
                </Route>
            </Switch>
        </MetaLayout>
    );
};

export default PostAuth;
